<template>
  <!-- 选择商品弹窗 -->
  <el-dialog
    title="选择商品"
    :visible.sync="dialogFormVisible"
    :before-close="handleDialogClose"
    width="820px"
  >
    <div class="screen-box">
      <div class="line">
        <div class="item" style="margin-right: 72px;">
          <span class="item-name">指定品牌：</span>
          <!-- 指定品牌弹出框 -->
          <el-popover width="280" v-model="brandVisible">
            <div class="brand-checked-wrapper">
              <div class="wrapper-header">
                <span style="float: left">指定品牌</span>
                <div style="clear: both"></div>
              </div>
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="checkedBrands"
                @change="handleCheckedBrandsChange"
              >
                <div
                  v-infinite-scroll="load"
                  style="overflow:auto;height:200px;"
                  infinite-scroll-disabled="disabled1"
                >
                  <el-checkbox
                    :label="item"
                    :key="index"
                    v-for="(item, index) in brandOptions"
                    style="display: block; margin-bottom: 8px;"
                    >{{ item.pidName }}</el-checkbox
                  >
                </div>
              </el-checkbox-group>
            </div>
            <div
              style="justify-content: center;display:flex;align-items:center;"
            >
              <span style="margin-right:5px"
                >共{{ specifyformcrowdTotal }}条</span
              >
              <el-button size="mini" @click="brandVisible = false"
                >取消</el-button
              >
              <el-button type="primary" size="mini" @click="brandConfirm()"
                >确定</el-button
              >
            </div>
            <el-button
              slot="reference"

              size="small"
              class="brandButton"
              >{{
                checkedBrands.length > 0
                  ? "已选择" + checkedBrands.length + "个"
                  : "默认全部"
              }}</el-button
            >
          </el-popover>
        </div>
        <div class="item">
          <el-select
            v-model="classifyValue"
            placeholder="淘宝类目"
            class="classify-select"
            size="small"
            @change="classifyChange"
          >
            <el-option
              v-for="item in classifyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-popover
            placement="bottom"
            width="300"
            v-model="visible"
            popper-class="poper"
          >
            <div class="popper-wrapper">
              <el-tree
                ref="taobaoTree"
                node-key="id"
                v-if="classifyIndex === 1"
                :data="taobaoCats"
                :props="props"
                show-checkbox
                @check-change="handleCheckChange"
              ></el-tree>
              <el-tree
                ref="sellerTree"
                node-key="id"
                v-else-if="classifyIndex === 2"
                :data="sellerCats"
                :props="props"
                show-checkbox
                @check-change="handleCheckChange"
              ></el-tree>
            </div>
            <div style="text-align: right; margin-top: 20px">
              <el-checkbox
                v-model="checkedAll"
                @change="handleCheckAllChangeTaoBao"
                style="float: left; line-height: 26px"
                >全选</el-checkbox
              >
              <el-button size="mini" type="text" @click="visible = false"
                >取消</el-button
              >
              <el-button type="primary" size="mini" @click="getCheckedKeys()"
                >确定</el-button
              >
            </div>
            <el-button slot="reference" size="small" class="goods-button">
              {{
                classifyIdArray.length > 0
                  ? "已选择" + classifyIdArray.length + "项"
                  : "默认全部"
              }}
            </el-button>
          </el-popover>
        </div>
      </div>
      <div class="line">
        <div class="item" style="margin-right: 15px">
          <span class="item-name">商品名称：</span>
          <el-input
            class="short-input"
            style="width: 300px"
            placeholder="请输入商品名称"
            size="small"
            v-model="itemTitle"
          ></el-input>
        </div>
        <div class="item" style="margin-right: 15px">
          <span class="item-name">商品ID：</span>
          <el-input
            class="short-input"
            style="width: 300px"
            placeholder="请输入商品ID,多个商品ID间用逗号分隔"
            size="small"
            @input="validNum"
            v-model="numIid"
          ></el-input>
        </div>
      </div>
      <div class="line">
        <el-button
          class="button"
          size="small"
          type="primary"
          @click="searchList()"
          >查询</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableShopData"
      stripe
      style="width: 90%; margin: 0 auto"
      :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
      :cell-style="{ 'text-align': 'left' }"
    >
      <el-table-column width="100">
        <template slot-scope="scope">
          <img
            :src="scope.row.logo"
            class="avar"
            alt="商品图片"
            style="height: 60px; width: 60px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="skuName" label="商品名称" width="300">
        <template slot-scope="scope">
          <a :href="scope.row.itemUrl" target="_blank"
            >{{ scope.row.skuName }}<br />
            ¥{{ scope.row.jdPrice }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="skuId" label="SKU ID" width="200">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="chooseShop(scope.row)"
            style="width: 50px"
            >选择</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin: 40px 80px 0 0; text-align: right"
      background
      @size-change="handleSizeChangeThr"
      @current-change="handleCurrentChangeThr"
      :current-page="formShopList.current"
      :page-sizes="[5, 10, 30, 50, 100]"
      :page-size="formShopList.size"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
      :total="totalListThr"
    ></el-pagination>
  </el-dialog>
</template>

<script>
import { getBrandList, getTaobaoItemList,getTaobaocats,
  getSellercats, } from "@/api/public1";
export default {
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      numIid: "", //商品ID
      itemTitle: "", // 商品名称
      classifyIdArray: [],
      checkedAll: false,
      props: {
        label: "speName001",
        children: "child",
      },
      taobaoCats: [], //淘宝类目
      sellerCats: [], //店铺类目
      classifyIndex: 1,
      visible: false, //类目渲染
      classifyOptions: [
        {
          value: 1,
          label: "淘宝类目",
        },
        {
          value: 2,
          label: "店铺类目",
        },
      ],
      classifyValue: 1,
      specifyformcrowdTotal: 0,
      brandOptions: [], //品牌列表
      checkedBrands: [], //选中品牌
      brandVisible: false, //指定品牌弹出框

      tableShopData: [], // 表格数据
      totalListThr: 0, // 总条数
      formShopList: { current: 1, size: 5, skuStatus: 1 }, // 分页器
    };
  },
  created() {
    this.getShopList();
    getBrandList({}).then((res) => {
      // console.log("%c 品牌列表", "color: green", res.data);
      // if(res.code === 200){
      console.log(res);
      this.specifyData = res.data.dataList;
      this.brandOptions = this.specifyData;
      this.specifyformcrowdTotal = parseInt(res.data.pageInfo.total);
      // };
      /*
        * 获取淘宝类目
        * */
      getTaobaocats({}).then((res) => {
        // console.log("%c 淘宝类目", "color: green", res.data);
        this.cats = res.data;
        this.taobaoCats = res.data;
      });
      /*
        * 获取店铺类目
        * */
      getSellercats({}).then((res) => {
        // console.log("%c 店铺类目", "color: green", res.data);
        this.sellerCats = res.data;
      });
    });
  },
  methods: {
    /*
     * 查询按钮
     * */
    searchList() {
      // 执行查询接口
      this.getShopList();
    },
    //获取店铺商品
    getShopList() {
      const self = this;
      let checkedBrandsString = self.checkedBrandsString, //指定品牌ID数组
        classifyIndex = self.classifyIndex, //商品类目类型
        classifyIdString = self.classifyIdString, //宝贝类目id数组
        itemTitle = self.itemTitle, //商品名称(请输入商品名称、商品编码、商品id、关键词)
        goodValue = "", //商品状态
        startPrice = "", //开始价格
        endPrice = ""; //结束价格
      // 判断商品类目 0店铺类目 1淘宝类目
      if (classifyIndex === 2) {
        // 店铺
        classifyIndex = 0;
      }
      // 判断商品状态 不填''查全部，在售 1，待售 2
      if (self.goodValue === 0) {
        goodValue = "";
      }
      let formData = {
        approveStatus: goodValue,
        categoryType: classifyIndex,
        cid: classifyIdString,
        endPrice: endPrice,
        itemTitle: itemTitle, //商品名称
        numIid: self.numIid, //商品id
        pageNum: self.formShopList.current,
        pageSize: self.formShopList.size,
        pid: checkedBrandsString,
        startPrice: startPrice,
      };
      getTaobaoItemList(formData).then((res) => {
        console.log("商品列表", res);
        this.tableShopData = res.data.dataList.map((item) => {
          return {
            ...item,
            logo: item.picUrl,
            discount: item.price,
            wareId: item.numIid,
            skuId: item.numIid,
            skuName: item.itemTitle,
            jdPrice: item.price,
          };
        });
        this.totalListThr = Number(res.data.pageInfo.total);
      });
    },

    /* 品牌弹窗确认按钮 */
    brandConfirm() {
      const that = this;
      let checkedBrands = that.checkedBrands;
      let checkedBrandsArray = [];
      checkedBrands.forEach(function(value) {
        checkedBrandsArray.push(value.pid);
      });
      // console.log("%c 选中的品牌Id", "color: green", checkedBrandsArray);
      that.checkedBrandsString = checkedBrandsArray.join(",");
      that.brandVisible = false;
    },
    //
    handleCheckedBrandsChange(value) {
      // console.log("%c 品牌单选事件", "color: green", value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.brandOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.brandOptions.length;
    },
    // 商品搜索
    load() {
      // let index = this.loadIndex;
      // let data =  this.specifyData[index];
      // this.brandOptions.push(data);
      // this.loadIndex++;
      let data = [];
      console.log('specifyform',this.specifyform);
      getBrandList(this.specifyform)
        .then((res) => {
          // console.log("%c 品牌列表", "color: green", res.data);
          if (res.code === 200) {
            console.log(res);
            data = res.data.dataList;
            data.forEach((item) => {
              this.specifyData.push(item);
            });
            this.brandOptions = this.specifyData;
          }
        })
        .then(() => {
          this.specifyform.pageNum++;
        });
    },

    //  监听类目的变化
    classifyChange(value) {
      this.classifyIndex = value;
      this.checkedAll = false;
      this.classifyIdArray = [];
      this.classifyIdString = "";
    },
    /*
     * 树形控件相关
     * */
    handleCheckChange(data, checked, indeterminate) {
      if (this.classifyIndex === 1) {
        let arr = this.$refs.taobaoTree.getCheckedKeys();
      } else {
        let arr = this.$refs.sellerTree.getCheckedKeys();
      }
    },

    getCheckedKeys() {
      const that = this;
      let classifyIndex = that.classifyIndex;
      let classifyIdArray = [];
      if (classifyIndex == 1) {
        // console.log(that.$refs.taobaoTree.getCheckedKeys());
        classifyIdArray = that.$refs.taobaoTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      } else if (classifyIndex == 2) {
        // 获取所有选中的id
        // console.log(that.$refs.sellerTree.getCheckedKeys());
        classifyIdArray = that.$refs.sellerTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      }
      that.visible = false;
    },

    /*
     * 商品类目全选按钮监听事件
     * */
    handleCheckAllChangeTaoBao(val) {
      if (val) {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes(this.taobaoCats);
        } else {
          this.$refs.sellerTree.setCheckedNodes(this.sellerCats);
        }
      } else {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes([]);
        } else {
          this.$refs.sellerTree.setCheckedNodes([]);
        }
      }
    },

    //
    validNum(val) {
      this.numIid = val.replace(/[^0-9\,]/g, "");
    },

    // 关闭弹窗
    handleDialogClose() {
      this.$emit("close");
    },

    //实物选择
    chooseShop(val) {
      this.$emit("check", val);
      console.log(val);
      // this.objectForm.logo = val.logo;
      // this.objectForm.name = val.skuName.substr(0, 12);
      // this.objectForm.discount = val.jdPrice;
      // this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
      // this.dialogFormVisible = false;
    },

    //分页事件
    handleSizeChangeThr(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChangeThr(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
  },
};
</script>
<style scoped lang="scss">
.screen-box {
  .line {
    font-size: 14px;
    color: #666666;
    margin-bottom: 10px;
    .item {
      display: inline-block;
      vertical-align: middle;
      // margin-right: 55px;
      .input {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
      }
      .brandButton {
        width: 300px;
      }
      .classify-select {
        display: inline-block;
        vertical-align: middle;
        width: 145px;
        margin-right: 13px;
      }
      .goods-button {
        display: inline-block;
        vertical-align: middle;
        width: 141px;
      }
      .long-input {
        width: 270px;
      }
      .goods-select {
        width: 200px;
      }
      .short-input {
        width: 85px;
        display: inline-block;
        vertical-align: middle;
      }
      .text {
        display: inline-block;
        margin: 0 10px;
      }
    }
  }
}
</style>
